import React from 'react';
import { Modal } from 'react-bootstrap'; 
import styles from './remove-access-popup.module.scss';
import UTEButton from 'src/components/ute-button';

interface IRemovePopupProps {
	auName: string;
	auRegistrationId: number;
	hide: () => void;
	deleteThirdPartyUser: () => void;
	deleteButtonDisabled: boolean;
}
const RemoveAccessPopup = ({ auName, auRegistrationId, hide, deleteThirdPartyUser, deleteButtonDisabled }: IRemovePopupProps) => {
	return (
		<>
			<Modal.Body className={styles.bodyStyle}>
				<div className={styles.deleteMessage}>
					Are you sure you want to revoke
					<span> {auName}'s </span> access rights?
				</div>
			</Modal.Body>
			<Modal.Footer className={styles.footerStyle}>
				<UTEButton
					text='No, Keep'
					className={styles.noButton}
					onClick={hide}
					disabled={deleteButtonDisabled}
					dataTestAuto='bf07a142-3db8-446d-acbe-5d1279b9b6c2'
				/>
				<UTEButton
					text='Yes, Revoke'
					className={styles.yesButton}
					onClick={deleteThirdPartyUser}
					disabled={deleteButtonDisabled}
					dataTestAuto='df36ac7c-8da4-4d47-a568-5fa4248719a4'
				/>
			</Modal.Footer>
		</>
	);
};

export default RemoveAccessPopup;